import i18nFactory from '@yandex-int/i18n';
import { Link, Spin } from 'lego-on-react';
import React from 'react';

import { Shape2, Shape2Icon, Shape2Tone } from '../../components/Shape2/Shape2';
import { Bem } from '../../service/Bem/Bem';
import { UploadCreative, UploadStatus } from '../Html5Upload/typings';
import { PcodeStaticCanvasPreview } from '../PcodeStaticCanvasPreview/PcodeStaticCanvasPreview';

import './Html5UploadingFiles.css';
import * as keyset from './Html5UploadingFiles.i18n';

const i18n = i18nFactory(keyset);
const BLOCK = 'html5-files';

class ProgressOrErrorCreativePreview extends React.PureComponent<{
    creative: UploadCreative;
    delete: (creative: UploadCreative) => void;
    repeat: () => void;
}> {
    state = { isErrorsVisible: false };

    render() {
        const { creative } = this.props;
        const isError = creative.status === UploadStatus.ERROR;
        let errorsList = '';
        if (creative.errors) {
            errorsList = creative.errors.join(', ');
        }

        return (
            <div className={Bem.cls(BLOCK, 'item')}>
                <div className={Bem.cls(BLOCK, 'item-line')}>
                    <table className={Bem.cls(BLOCK, 'item-table')}>
                        <tbody>
                            <tr className={Bem.cls(BLOCK, 'item-tr')}>
                                <td className={Bem.cls(BLOCK, 'item-name')}>{creative.name}</td>
                                <td className={Bem.cls(BLOCK, 'item-status')}>
                                    {isError ? (
                                        <div className={Bem.cls(BLOCK, 'circle')} />
                                    ) : (
                                        <Spin cls={Bem.cls(BLOCK, 'spin')} progress={true} size={'xxs'} />
                                    )}
                                    {isError ? i18n('not-meet-requirements') : i18n('uploading')}
                                </td>
                                <td className={Bem.cls(BLOCK, 'item-toggle-error')}>
                                    {isError && (
                                        <Link theme={'pseudo'} text={i18n('more')} onClick={this.onToggleErrors} />
                                    )}
                                </td>
                            </tr>
                        </tbody>
                    </table>
                    <div className={Bem.cls(BLOCK, 'item-actions')}>
                        {isError && <Link theme={'pseudo'} text={i18n('repeat')} onClick={this.onRepeat} />}
                        <div className={Bem.cls(BLOCK, 'creative-trash')}>
                            <Shape2
                                cls={Bem.cls(BLOCK, 'trash-icon')}
                                icon={Shape2Icon.trashbin}
                                width={12}
                                height={12}
                                onClick={this.onDelete}
                                tone={Shape2Tone.darkGrey}
                                hoverable={true}
                            />
                        </div>
                    </div>
                </div>
                {this.state.isErrorsVisible && <div className={Bem.cls(BLOCK, 'creative-errors')}>{errorsList}</div>}
            </div>
        );
    }

    private onToggleErrors = () => {
        this.setState({ isErrorsVisible: !this.state.isErrorsVisible });
    };

    private onRepeat = () => {
        this.props.delete(this.props.creative);
        this.props.repeat();
    };

    private onDelete = () => {
        this.props.delete(this.props.creative);
    };
}

class SuccessCreativePreview extends React.PureComponent<{
    creative: UploadCreative;
    delete: (creative: UploadCreative) => void;
}> {
    render() {
        const { creative } = this.props;
        const creativeUrl = creative.creativeUrl || '';
        const width = creative.width || 0;
        const height = creative.height || 0;

        return (
            <div className={Bem.cls(BLOCK, 'creative')}>
                <PcodeStaticCanvasPreview
                    key={creative.id}
                    previewUrl={creativeUrl}
                    currentSize={{
                        width,
                        height
                    }}
                />
                <div className={Bem.cls(BLOCK, 'creative-controls')}>
                    {`${creative.name} — ${creative.width}x${creative.height}`}
                    <Shape2
                        cls={Bem.cls(BLOCK, 'trash-icon')}
                        icon={Shape2Icon.trashbin}
                        width={12}
                        height={12}
                        onClick={this.onDelete}
                        tone={Shape2Tone.darkGrey}
                        hoverable={true}
                    />
                </div>
            </div>
        );
    }

    private onDelete = () => {
        this.props.delete(this.props.creative);
    };
}

export class Html5UploadingFiles extends React.PureComponent<{
    progressItems: UploadCreative[];
    successItems: UploadCreative[];
    errorItems: UploadCreative[];
    delete: (creative: UploadCreative) => void;
    repeat: () => void;
}> {
    render() {
        const { progressItems, successItems, errorItems } = this.props;
        const notReady = progressItems.concat(errorItems);

        return (
            <div className={BLOCK}>
                {notReady.map((creative, ind) => {
                    return (
                        <div key={ind}>
                            <ProgressOrErrorCreativePreview
                                creative={creative}
                                delete={this.props.delete}
                                repeat={this.props.repeat}
                            />
                        </div>
                    );
                })}
                {successItems.map((creative, ind) => {
                    return (
                        <div key={ind}>
                            <SuccessCreativePreview creative={creative} delete={this.props.delete} />
                        </div>
                    );
                })}
            </div>
        );
    }
}
